import { render, staticRenderFns } from "./DialogAplicativos.vue?vue&type=template&id=39bca42d"
import script from "./DialogAplicativos.vue?vue&type=script&lang=js"
export * from "./DialogAplicativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports